import { createReducer, on } from '@ngrx/store'
import * as StageActions from './stage.actions'
import { StageState } from './stage.state'

export const initialState: StageState = {
   user: {},
}

export const stageReducer = createReducer(
   initialState,
   on(StageActions.setUser, (state, action) => {
      return { ...state, user: action.user }
   }),
   on(StageActions.searchCRMOrganizationList, (state) => ({ ...state, fromCRMOrganizations: undefined, isLoadingCRMOrganizations: true })),
   on(StageActions.searchCRMOrganizationListSuccess, (state, action) => ({
      ...state,
      fromCRMOrganizations: action.response,
      isLoadingCRMOrganizations: false,
   })),
   on(StageActions.searchCRMOrganizationListFailure, (state) => ({ ...state, isLoadingCRMOrganizations: false })),
   on(StageActions.cleanCRMOrganizations, (state) => ({
      ...state,
      fromCRMOrganizations: undefined,
   })),
   on(StageActions.setSectors, (state) => ({ ...state, sectors: undefined })),
   on(StageActions.setSectorsSuccess, (state, action) => ({ ...state, sectors: action.sectors })),
   on(StageActions.setSoughtPartnerCountries, (state) => ({ ...state, soughtPartnerCountries: undefined })),
   on(StageActions.setSoughtPartnerCountriesSuccess, (state, action) => ({ ...state, soughtPartnerCountries: action.soughtPartnerCountries })),
   on(StageActions.getPNOUserNotifications, (state) => ({ ...state, isLoadingUserNotifications: true })),
   on(StageActions.getPNOUserNotificationsSuccess, (state, action) => ({
      ...state,
      userNotifications: action.userNotifications,
      isLoadingUserNotifications: false,
   })),
   on(StageActions.getPNOUserNotificationsFailure, (state) => ({ ...state, isLoadingUserNotifications: false })),
   on(StageActions.cleanNotifications, (state) => ({ ...state, userNotifications: undefined }))
)
